import { useModal } from 'modals';
import { Link } from 'react-router';

import Text from '@cartwhl/ui/base/Text';
import GoButton from '@cartwhl/ui/input/GoButton';

const column1Links = [
  { label: 'Product', to: '/#products' },
  { label: 'Data', to: '/data' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Company', to: '/company' },
  {
    label: 'Tutorials',
    to: 'https://www.youtube.com/playlist?list=PLAop09wyy5_LLIaYTt4Cs1PwyxNC2FuZG',
    external: true,
  },
  {
    label: 'Canvas Docs',
    to: 'https://docs.getcartwheel.com/docs/getting-started/introduction',
    external: true,
  },
  {
    label: 'API Docs',
    to: 'https://api-docs.getcartwheel.com/',
    external: true,
  },
];

const legalLinks = [
  { label: 'Privacy policy', to: '/privacy-policy' },
  { label: 'Terms & conditions', to: '/terms-of-use' },
];

const column2Links = [
  { label: 'Contact us', action: 'contact-modal' as const },
  {
    label: 'LinkedIn',
    to: 'https://linkedin.com/company/getcartwheel',
    external: true,
  },
  { label: 'YouTube', to: 'https://youtube.com/@getcartwheel', external: true },
  { label: 'X', to: 'https://x.com/getcartwheel', external: true },
  {
    label: 'Instagram',
    to: 'https://instagram.com/getcartwheel',
    external: true,
  },
  { label: 'Tiktok', to: 'https://tiktok.com/@getcartwheel', external: true },
];

export default function Footer() {
  const { open } = useModal();
  return (
    <footer className="container">
      <div className="border-primary py-22 grid grid-cols-2 gap-6 gap-y-16 border-t lg:flex lg:items-start lg:justify-between">
        <div className="contents lg:flex lg:items-start lg:justify-between">
          {/* Logo */}
          <div className="lg:order-0 order-1 flex-none lg:mt-[-18px] lg:w-28">
            {/* <Logo className="h-[40px] w-[40px] lg:h-[52px] lg:w-[52px]" /> */}
            <img
              className="h-16 w-16"
              src="/images/company/cartwheel_forward.gif"
              alt="Spinning Cartwheel logo"
            />
          </div>

          {/* Info column */}
          <div className="text-tertiary text-primary-none w-54 lg:order-0 order-5 flex-none">
            <Text as="div" variant="web/body/medium/md">
              Cartwheel ©{new Date().getFullYear()}
              <address className="mt-6 not-italic leading-5">
                Cartwheel Inc. <br />
                46 Howard Street <br />
                Suite 607 <br />
                New York, NY 10013 <br />
                USA
              </address>
            </Text>
            <div className="mt-6 flex flex-col gap-3.5">
              {legalLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-tertiary hover:text-primary transition-colors"
                >
                  <Text variant="web/body/medium/md">{link.label}</Text>
                </Link>
              ))}
            </div>
          </div>

          {/* Column 1 */}
          <div className="lg:w-54 lg:order-0 order-3 flex flex-none flex-col gap-3.5">
            {column1Links.map((link) =>
              link.external ? (
                <a
                  key={link.label}
                  href={link.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-tertiary hover:text-primary transition-colors"
                >
                  <Text variant="web/body/medium/md">{link.label}</Text>
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-tertiary hover:text-primary transition-colors"
                >
                  <Text variant="web/body/medium/md">{link.label}</Text>
                </Link>
              ),
            )}
          </div>

          {/* Column 2 */}
          <div className="lg:w-54 lg:order-0 order-4 flex flex-none flex-col gap-3.5">
            {column2Links.map((link) => {
              if ('action' in link && link.action === 'contact-modal') {
                return (
                  <button
                    key={link.label}
                    onClick={() => open('ENTERPRISE_CONTACT', {})}
                    className="text-tertiary hover:text-primary cursor-pointer text-left transition-colors"
                  >
                    <Text variant="web/body/medium/md">{link.label}</Text>
                  </button>
                );
              }
              if (link.external) {
                return (
                  <a
                    key={link.label}
                    href={link.to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-tertiary hover:text-primary transition-colors"
                  >
                    <Text variant="web/body/medium/md">{link.label}</Text>
                  </a>
                );
              }
              return (
                <Link
                  key={link.label}
                  to={link.to!}
                  className="text-tertiary hover:text-primary transition-colors"
                >
                  <Text variant="web/body/medium/md">{link.label}</Text>
                </Link>
              );
            })}
          </div>
        </div>

        {/* Right side - Buttons */}
        <div className="lg:order-0 order-2 flex items-center justify-end">
          <Link to="/pricing" className="inline-flex shrink-0">
            <GoButton variant="animate">Free trial</GoButton>
          </Link>
        </div>
      </div>
    </footer>
  );
}
